<div class="card form-card">
  <div class="card-body">

    <!-- <form #frm="ngForm" (ngSubmit)="saveData()"> -->
      <!-- <input type="hidden" id="id" name="id" [(ngModel)]="frmData.id"> -->

      <div class="row g-3">
        <div class="col-md-6">
          <label for="inst_name" class="form-label">
            Institute Name <span class="text-danger">*</span>
          </label>
          <input type="text" class="form-control" id="inst_name" name="inst_name" [(ngModel)]="frmData.inst_name"
            #inst_name="ngModel" required>
        </div>

        <div class="col-md-3">
          <label for="inst_type" class="form-label">
            Institute Type
          </label>
          <select class="form-select" id="inst_type" name="inst_type" [(ngModel)]="frmData.inst_type">
            <option value="">Select</option>
            @for(it of dataService.institute_types; track $index;) {
            <option value="{{it.code}}">{{it.name}}</option>
            }
          </select>
        </div>

        <div class="col-md-3">
          <label for="student_counts" class="form-label">
            Student Count
          </label>
          <input type="number" class="form-control" id="student_counts" name="student_counts"
            [(ngModel)]="frmData.student_counts">
        </div>

        <div class="col-md-6">
          <label for="full_name" class="form-label">
            Full Name <span class="text-danger">*</span>
          </label>
          <input type="text" class="form-control" id="full_name" name="full_name" [(ngModel)]="frmData.full_name"
            #full_name="ngModel" required>
        </div>

        <div class="col-md-3">
          <label for="designation" class="form-label">
            Designation
          </label>
          <select class="form-select" id="designation" name="designation" [(ngModel)]="frmData.designation">
            <option value="">Select</option>
            @for(desi of dataService.designations; track $index;) {
            <option value="{{desi.code}}">{{desi.name}}</option>
            }
          </select>
        </div>

        <div class="col-md-3">
          <label for="mobile_no" class="form-label">
            Mobile Number <span class="text-danger">*</span>
          </label>
          <input type="tel" class="form-control" id="mobile_no" name="mobile_no" maxlength="10"
            [(ngModel)]="frmData.mobile_no" required>
        </div>

        <div class="col-md-6">
          <label for="email_id" class="form-label">
            Email Address <span class="text-danger">*</span>
          </label>
          <input type="email" class="form-control" id="email_id" name="email_id" [(ngModel)]="frmData.email_id" required>
        </div>

        <div class="col-md-6">
          <label for="inst_website" class="form-label">
            Institute Website
          </label>
          <input type="url" class="form-control" id="inst_website" name="inst_website" [(ngModel)]="frmData.inst_website">
        </div>

        <div class="col-12">
          <label for="address" class="form-label">
            Address
          </label>
          <textarea class="form-control" id="address" name="address" rows="3" [(ngModel)]="frmData.address"></textarea>
        </div>

        <div class="col-md-4">
          <label for="city" class="form-label">
            City
          </label>
          <input type="text" class="form-control" id="city" name="city" [(ngModel)]="frmData.city">
        </div>

        <div class="col-md-4">
          <label for="state" class="form-label">
            State
          </label>
          <input type="text" class="form-control" id="state" name="state" [(ngModel)]="frmData.state">
        </div>

        <div class="col-md-4">
          <label for="pincode" class="form-label">
            Pincode
          </label>
          <input type="text" class="form-control" id="pincode" name="pincode" maxlength="6" [(ngModel)]="frmData.pincode">
        </div>

        <div class="col-md-4">
          <label for="source" class="form-label">
            Source
          </label>
          <select class="form-select" id="source" name="source" [(ngModel)]="frmData.source">
            <option value="">Select</option>
            @for(s of dataService.sources; track s.code) {
            <option value="{{s.code}}">{{s.name}}</option>
            }
          </select>
        </div>

        <div class="col-md-4">
          <label for="pref_date" class="form-label">
            Preferred Date
          </label>
          <input type="date" class="form-control" id="pref_date" name="pref_date" [(ngModel)]="frmData.pref_date">
        </div>

        <div class="col-md-4">
          <label for="pref_time" class="form-label">
            Preferred Time
          </label>
          <input type="time" class="form-control" id="pref_time" name="pref_time" [(ngModel)]="frmData.pref_time">
        </div>

        <div class="col-md-4">
          <label for="req_date" class="form-label">
            Request Date
          </label>
          <input type="date" class="form-control" id="req_date" name="req_date" [(ngModel)]="frmData.req_date">
        </div>

        <div class="col-md-4">
          <label for="status" class="form-label">
            Status
          </label>
          <select class="form-select" id="status" name="status" [(ngModel)]="frmData.status">
            <option value="New">New</option>
            <option value="Contacted">Contacted</option>
            <option value="Follow Up">Follow Up</option>
            <option value="Demo Scheduled">Demo Scheduled</option>
            <option value="Interested">Interested</option>
            <option value="Rejected">Rejected</option>
            <option value="Converted">Converted</option>
            <option value="Closed">Closed</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="is_active" class="form-label">
            Active
          </label>
          <select class="form-select" id="is_active" name="is_active" [(ngModel)]="frmData.is_active">
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </div>

        <div class="col-12">
          <label for="message" class="form-label">
            Message
          </label>
          <textarea class="form-control" id="message" name="message" rows="4" [(ngModel)]="frmData.message"></textarea>
        </div>
      </div>
      <!-- <hr>
      <div class="d-flex justify-content-end gap-2">
        <button type="reset" class="btn btn-secondary">
          <i class="bi bi-arrow-counterclockwise"></i>
          Reset
        </button>

        <button type="submit" class="btn btn-primary" [disabled]="frm.invalid">
          <i class="bi bi-floppy"></i>
          Save
        </button>
      </div> -->
    <!-- </form> -->

  </div>
</div>